import { PageBlockProps } from '@design-system/page-block';

import { BodyRenderExternalData } from '~/components/BodyRender/models';
import { headingBlockMapper } from '~/mappers/headingBlock';
import { nlToBr } from '~/utils/stringUtils/stringUtils';

import { SalsifyText } from './models';

export const salsifyTextMapper = (
  {
    salsifyDescriptionField,
    salsifyHeadlineField,
    customHeadline,
    pageBlockUI: [
      {
        ui: { disableGutters, element, headingUI, maxWidth, mode },
      },
    ],
    componentId,
    uid,
  }: SalsifyText,
  _currentPageUid: string,
  { salsifyExternalData }: BodyRenderExternalData
): PageBlockProps => {
  if (!salsifyExternalData) {
    throw new Error('No salsify data');
  }

  return {
    disableGutters,
    element,
    heading: headingBlockMapper({
      ui: headingUI,
      descriptionRte: salsifyDescriptionField
        ? nlToBr(salsifyExternalData[salsifyDescriptionField])
        : null,
      headline: salsifyHeadlineField
        ? salsifyExternalData[salsifyHeadlineField]
        : customHeadline,
      detail: null,
      link: [],
      button: [],
    }),
    id: componentId,
    maxWidth,
    mode,
    className: 'salsify-text-block',
    componentUid: uid,
  } as PageBlockProps;
};
